<script setup lang="ts">
import { computed } from 'vue';
import { usePrice } from '@phoenix/composables/price';

export interface ProductPriceProps {
  text?: string | number;
  value?: number;
  priceOnDemand?: boolean;
  currency?: string;
  shouldDisplayFromPrice?: boolean;
  shouldDisplayCurrencyFirst?: boolean;
  vatInformation?: string;
}
const props = withDefaults(defineProps<ProductPriceProps>(), {
  text: '',
  value: 0,
  priceOnDemand: true,
  currency: '',
  shouldDisplayFromPrice: false,
  shouldDisplayCurrencyFirst: true,
  vatInformation: '',
});

const { localizedPriceDisplayValue } = usePrice();

const displayedPrice = computed(() =>
  localizedPriceDisplayValue(
    {
      text: props.text,
      priceOnDemand: props.priceOnDemand,
      currency: props.currency,
      shouldDisplayCurrencyFirst: props.shouldDisplayCurrencyFirst,
    },
    props.shouldDisplayFromPrice,
    true,
  ),
);
</script>

<template>
  <span v-html="displayedPrice" />
</template>
